import React from 'react';
import { Browser } from '@capacitor/browser';
import { Box, useColorModeValue } from '@chakra-ui/react';

import { PrivacyPolicyContent } from 'clipsal-cortex-ui/src/components/PrivacyPolicyContent';
import { CORTEX_PRIVACY_POLICY_URL } from 'clipsal-cortex-utils/src/constants/common-constants';

import { ProfilePageBase } from '../../features/profile/ProfilePageBase';

export function PrivacyPolicy() {
  const hoverColor = useColorModeValue('white', 'gray.900');

  return (
    <Box
      data-testid="privacy-policy-btn"
      onClick={() => Browser.open({ url: CORTEX_PRIVACY_POLICY_URL })}
      py={3}
      px={4}
      _hover={{ bg: hoverColor }}
      cursor={'pointer'}
    >
      Privacy Policy
    </Box>
  );
}

export function PrivacyPolicyPage() {
  return (
    <ProfilePageBase title="Privacy Policy">
      <Box px={4} pb={4} data-testid="privacy-policy-content">
        <PrivacyPolicyContent />
      </Box>
    </ProfilePageBase>
  );
}
